import {addDoc, collection, serverTimestamp} from 'firebase/firestore';
import {COLLECTION_CONTACT_MESSAGE, ContactMessageState, contactMessageWriteSchema} from '@cp/model';
import {firebaseFirestore} from '../../config/firebase';

export async function submitContactMessage(
  data: {name: string; email: string; message: string},
  uid?: string,
): Promise<{messageId: string}> {
  const parsed = contactMessageWriteSchema.parse({...data, uid});
  const col = collection(firebaseFirestore, COLLECTION_CONTACT_MESSAGE);
  const docData = {
    ...parsed,
    state: ContactMessageState.UNREAD,
    createdAt: serverTimestamp(),
  };
  const ref = await addDoc(col, docData);
  return {messageId: ref.id};
}
